module.exports = __webpack_public_path__ + "img/H000150_goldenapple.f6ceae90.png";